import React from "react";
import "./News.css";
import newsImg1 from "../../Assets/NewsImg-1.jpeg";
import newsImg2 from "../../Assets/NewsImg-2.jpg";
import newsImg3 from "../../Assets/NewsImg-3.jpg";

const News = () => {
  const NewsData = [
    {
      id: 0,
      img: newsImg1,
      month: "March",
      date: 21,
      text: "Next Generation Report Ceremony held at Pakistan Institute for Parliamentary Services Islamabad .",
    },
    {
      id: 1,
      img: newsImg2,
      month: "March",
      date: 20,
      text: "The session on “Women's Empowerment and Financial Inclusion” being held by REMIT Pakistan.",
    },
    {
      id: 2,
      img: newsImg3,
      month: "March",
      date: 10,
      text: "Shaza Fatima Khawaja met with the National Women's Football Team in Lahore.",
    },
  ];
  return (
    <>
      <div className="news-container">
        <h2>Latest News</h2>
        <div className="news-box">
          {NewsData.map((items) => {
            return (
              <div key={items.id} className="news-card">
                <img src={items.img} alt="Shaza's images" />
                <div className="news-date">
                <p>{items.month} <span>{items.date}</span></p>
                  <div className="news-text">{items.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default News;
